module.exports = __webpack_public_path__ + "img/Jon Guiriba.7da1b650.jpg";